define([
	"csi",
	"csi/_base/underscore"
], function(csi,_) {
	
	/**
	 * Move any plugins in pluginsRight array to the front of the plugins array so CSS float to right works
	 * @param {Any[]} plugins - could include objects such as Export menu 
	 * @param {string[]} pluginsRight
	 * @return {Any[]} 
	 */
	function reorderRightPlugins(plugins, pluginsRight) {
		var hash = csi.hashArray(pluginsRight, null, Number);
		var right = new Array(pluginsRight.length);
		var left = _.filter(plugins, function(p) {
			var index = hash[p.name || p]; 
			if (index == null) {
				return true;
			}
			
			right[index] = p;
			return false;
		});
		
		// right will contain only plugins from pluginsRight that are in view and may be sparse, so need to compact
		return _.compact(right).concat(left);
	}

	return {
		reorderRightPlugins: reorderRightPlugins
	};
});